export default __webpack_public_path__ + "static/media/4.b07c8122.svg";